<template>
  <div class="card-form">
    <el-card>
      <b-row>
        <b-col md="4" lg="4">
          <b-img
            class="max-image"
            :src="
              $osscdn(formData.deImageCode) || '/image/static/img/nopic.jpg'
            "
            @click="imageView"
          ></b-img>
          <div v-show="false" class="images" v-viewer="{ movable: false }">
            <img
              v-for="src in lsPopImageData"
              :src="src.imageCode"
              :key="src.imageCode"
            />
          </div>
        </b-col>
        <b-col md="8" lg="8">
          <h3>{{ formData.deNo }}</h3>
          <div>
            <b-icon-star
              v-for="(str, index) in formData.lightStarList"
              :key="index"
              :variant="str"
              class="mr-1"
            ></b-icon-star>
            <b-icon-star
              v-for="str in formData.greyStarList"
              :key="str"
              class="mr-3"
            ></b-icon-star>
            <span>{{ formData.reviews }} reviews</span>
          </div>
          <hr />
          <h5 class="price m-t-0">
            {{ formData.deCategoryName ? formData.deCategoryName : '--' }}
          </h5>
          <p class="product-description">
            {{ formData.deNameEn ? formData.deNameEn : '--' }}
          </p>
          <p class="product-description">
            {{ formData.deName ? formData.deName : '--' }}
          </p>
          <p class="mb-1">
            {{ $l('form_label_category') || '素材分类' }}：{{
              formData.deCategoryName ? formData.deCategoryName : '--'
            }}
          </p>
          <p class="mb-1">
            {{ $l('form_label_remarks') || '备注说明' }}：{{
              formData.deMemo ? formData.deMemo : '--'
            }}
          </p>
          <p
            class="mb-1"
            v-for="(item, index) in formData.designInfoAttributeList"
            :key="index"
          >
            {{ item.label }}：{{ item.value ? item.value : '--' }}
          </p>
          <hr style="background-color:#e5e5e6;height:1px;border:none;" />
          <b-row class="pl-3">
            <b-button
              @click="addCart"
              class="mr-1"
              variant="outline-success"
              type="button"
              >Add to Cart</b-button
            >
            <b-button
              @click="addCollect"
              variant="outline-danger"
              type="button"
            >
              <i v-if="formData.state" class="fa fa-heart"></i>
              <i v-else class="fa fa-heart-o"></i>
            </b-button>
          </b-row>
        </b-col>
      </b-row>
    </el-card>
  </div>
</template>
<script>
export default {
  components: {},
  computed: {
    attrParams() {
      return {
        infoCode: this.formData.deCode,
        templateCategoryCode: this.formData.deCategoryCode,
        templateType: 'D'
      }
    }
  },
  // 数据
  data() {
    return {
      formData: {},
      productType: 'D',
      isJustShown: false, // 折叠状态
      lsPopImageData: [] // 预览产品图集合
    }
  },
  // 侦听器
  watch: {
    '$route.params'() {
      if (this.$route.params.deCode) {
        this.detailLoad(this.$route.params.deCode)
      }
    }
  },
  // 生命周期钩子
  mounted() {
    this.detailLoad(this.$route.params.deCode)
    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      this.isJustShown = isJustShown
    })
  },
  // 事件处理方法
  methods: {
    detailLoad(val) {
      // 初始化弹出预览产品图集合
      this.lsPopImageData = []
      let param = { deCode: val }
      this.$api.detailDesignElementsInfoApi(param).then((res) => {
        this.formData = res.body
        if (res.body.deImageCode) {
          let popViewImg = {
            imageCode: this.$osscdn(res.body.deImageCode)
          }
          this.lsPopImageData.push(popViewImg)
        }

        //this.$refs.attribute.load(this.attrParams);
      })
    },
    // 加入收藏/取消收藏
    addCollect() {
      let param = {
        sampleCode: this.formData.deCode,
        productType: this.productType
      }
      this.$api
        .saveAndCancelCollectApi(param)
        .then(() => {
          this.$set(this.formData, 'state', !this.formData.state)
          if (this.formData.state) {
            this.$message.success(this.$l('tips_collection_ok') || '收藏成功')
          } else {
            this.$message.success(
              this.$l('tips_collection_cancle') || '取消收藏'
            )
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    addCart() {
      this.$api
        .addCartApi({
          sampleCode: this.formData.deCode,
          productType: this.productType
        })
        .then(() => {
          this.$message.success(
            this.$l('tips_add_cart_ok') || '购物车添加成功！'
          )
          // this.$bvModal.msgBoxOk('购物车添加成功!', {
          //   title: 'Confirmation',
          //   size: 'sm',
          //   buttonSize: 'sm',
          //   okVariant: 'success',
          //   headerClass: 'p-2 border-bottom-0',
          //   footerClass: 'p-2 border-top-0',
          //   centered: true
          // }).then(value => {
          // }).catch(() => {})
        })
    },
    goBack() {
      this.$router.go(-1)
    },
    // 点击大图显示图片预览组件
    imageView() {
      if (this.formData.deImageCode) {
        const viewer = this.$el.querySelector('.images').$viewer
        viewer.show()
      }
    }
  }
}
</script>

<style lang="scss">
.table-c table {
  height: 30px;
}
.table-c table td {
  border-left: 1px solid #f4f4f4;
  border-bottom: 1px solid #f4f4f4;
  border-right: 1px solid #f4f4f4;
  border-top: 1px solid #f4f4f4;
  padding-left: 5px;
  height: 30px;
}
.table-tr {
  background-color: #fbfcfd;
}
.max-image {
  max-width: 100%;
  max-height: 320px;
  display: block;
}
tr:hover {
  background: #f3f4f6;
}
</style>
